/*
 *   File : add-family.js
 *   Author : https://evoqins.com
 *   Description : Add family modal which allows the admin to invite and add another client in the platform.
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';

//Custom components
import { CustomTextInput } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton, SecondaryButton } from '../Buttons';

//Style
import Color from "../../Style/color.scss"

const AddFamilyModal = (props) => {

    const [clientId, setClientId] = useState("");
    const [clientIdError, setClientIdError] = useState("");
    const [pan, setPan] = useState("");
    const [panError, setPanError] = useState("");
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        setClientIdError("");
    }, [clientId]);

    useEffect(() => {
        setPanError("");
    }, [pan]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("add-family-modal-close");
        button.click();
        props.handleClose();

        setTimeout(() => {
            setSuccess(false);
        }, 200);
    };

    // handle pan change 
    const _handlePanChange = (value) => {
        if (value.length <= 10) {
            setPan(value.toUpperCase());
        }
    }

    // handle send email
    const _handleSendEmail = () => {
        let is_valid = true;

        if (clientId.trim().length === 0) {
            setClientIdError("Please provide client ID");
            is_valid = false;
        }

        if (pan.trim().length === 0) {
            setPanError("Please provide PAN");
            is_valid = false;
        }

        if (is_valid === true) {
            setSuccess(true);
        }
    };

    return (
        <div className="modal fade"
            id="add-family-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="addFamilyModalLabel"
            aria-hidden="true">

            <div className={`${success ? 'modal-md' : 'modal-lg'} modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-28`}>
                <span id='add-family-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark">
                    {/* modal header */}
                    <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                        <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                            {success ? 'Success!' : 'Add family member'}
                        </h6>
                        <Icon icon='close'
                            size="1.125rem"
                            className="d-flex cursor-pointer"
                            onClick={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>
                        {success ?
                            <p className='mb-0 e-text-dark-gray e-primary-font e-font-16 e-font-weight-400 line-height-20px'>
                                The invitation email has been successfully sent .They can now proceed with the account setup and complete their signup.
                            </p>
                            :
                            <>
                                <div className='row pb-4 mb-2'>
                                    {/* Client ID */}
                                    <div className='col-6'>
                                        <CustomTextInput label="Client ID"
                                            placeholder="Enter ID"
                                            type="number"
                                            autoFocus={true}
                                            required={true}
                                            value={clientId}
                                            error={clientIdError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleSendEmail}
                                            handleChange={(e) => setClientId(e)} />
                                    </div>

                                    {/* PAN */}
                                    <div className='col-6'>
                                        <CustomTextInput label="PAN"
                                            placeholder="Enter PAN"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={pan}
                                            error={panError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleSendEmail}
                                            handleChange={_handlePanChange} />
                                    </div>
                                </div>

                                <div className='e-bg-magnolia-light p-3 border-radius-8 d-flex gap-1 align-items-start'>
                                    <Icon icon="info"
                                        size="1rem"
                                        color={Color.davys_grey_light}
                                        className="d-flex" />

                                    <p className='mb-0 e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                        An invitation email will be sent to the provided email address, allowing the recipient to complete the account setup and signup process.
                                    </p>
                                </div>
                            </>
                        }
                    </div>

                    {/* Modal footer */}
                    <div className='modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                        {success ?
                            <SecondaryButton name="Ok"
                                className="py-3 padding-52px-lr"
                                onClick={_handleCloseModal} />
                            :
                            <>
                                <SecondaryButton name="Cancel"
                                    className="py-3 padding-52px-lr"
                                    onClick={_handleCloseModal} />
                                <PrimaryButton name="Send Email"
                                    className="padding-52px-lr"
                                    onClick={_handleSendEmail} />
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddFamilyModal;

AddFamilyModal.defaultProps = {
    handleClose: () => { }
};